<template>
  <vx-card
    title="Work Hour"
    class="mt-base"
  >

    <vs-list>
      <listing-work-hour-item v-for="(item, index) in days" :key="index" :day="item" :data="data[item] || { open: false, from: '', to: '' }" @update="update" />
    </vs-list>

  </vx-card>
</template>

<script>
import ListingWorkHourItem from './ListingWorkHourItem'

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    update(data) {
      this.$emit('update', data)
    }
  },
  data() {
    return {
      days: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ]
    }
  },
  components: { ListingWorkHourItem }
}
</script>

